<template>
  <div class="detail-box">
    <el-image
      v-if="imgPreviewUrl.length"
      ref="previewImg"
      style="display: none"
      :src="imgPreviewUrl"
      :preview-src-list="imgPreviewUrl"
    >
    </el-image>
    <div class="content-box">
      <div class="flex flex-between padding-bottom-25 title-box">
        <span class="color-333 font-20 font-weight">{{ info.title }}</span>
        <div>
          <span
            class="margin-left-15 label-item font-14 font-light"
            v-for="(item, index) in info.label"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="margin-top-25" v-html="info.content"></div>
      <div class="flex flex-align-center margin-top-30">
        <span class="color-999 font-14 margin-right-40">{{ info.createTime }}</span>
        <div class="flex flex-align-center">
          <img style="width: 16px; height: 16px" src="./static/icon_article_pageView.png" />
          <span class="color-999 font-14 margin-left-5">{{
            info.pageView > 999 ? '999+' : info.pageView
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { articleInfo } from '@/api'
  export default {
    data() {
      return {
        info: {},
        isHot: false,
        content: '',
        imgPreviewUrl: []
      }
    },
    mounted() {
      window.previewImg = (url) => {
        const arr = [url]
        this.imgPreviewUrl.forEach((it) => {
          if (it !== arr[0]) {
            arr.push(it)
          }
        })
        this.imgPreviewUrl = arr
        setTimeout(() => {
          this.$refs.previewImg.showViewer = true
        }, 0)
      }
      const id = this.$route.params.id
      const isHot = this.$route.params.isHot
      if (isHot === 'true') {
        this.isHot = true
      }
      this.getDetail(id)
    },

    methods: {
      async getDetail(id) {
        this.$loading()
        const { code, data } = await articleInfo(id)
        if (code === 0) {
          data.content = data.content.replace(/<img src="[^>]*>/gi, (val) => {
            let src = val.split('<img src="')[1].split('" ')[0]
            let url =
              '<img style="width: 396px; height: 179px; margin: 20px 0; object-fit: scale-down;" onclick="window.previewImg(\'' +
              src +
              '\')" src="' +
              src +
              '">'
            this.imgPreviewUrl.push(src)
            return url
          })
          data.content = data.content.replaceAll('<p', '<p style="margin: 0"')
          this.info = data
        }
        this.$loading().close()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .detail-box {
    background: #f1f2f5;
    height: calc(100vh - 96px);
    padding: 20px 0;
    .content-box {
      margin: 0 220px;
      background: #ffffff;
      border-radius: 10px;
      padding: 25px 40px;
      max-height: calc(100vh - 136px);
      overflow-y: auto;
      box-sizing: border-box;
      .title-box {
        border-bottom: 1px dashed #e4e4e4;
        .label-item {
          color: #22c655;
          background: #e2f7e5;
          border-radius: 4px;
          padding: 4px 10px;
        }
      }
    }
  }
</style>
